import React, { useMemo, useRef, useState, useEffect, useContext } from "react";
import {
  Search,
  MoreVertical,
  Paperclip,
  Smile,
  Send,
  CheckCheck,
  Circle,
  ArrowLeft,
} from "lucide-react";

import { AddIcon } from "@chakra-ui/icons";
import { Box, Stack, Text } from "@chakra-ui/react";
import { useToast } from "@chakra-ui/react";
import axios from "../../AxiosInstance";
import { getSender, getSenderFull } from "../../config/ChatLogics";
import ChatLoading from "./ChatLoading";
import { BASE_URL } from "../../config/BaseUrls";

import { Button } from "@chakra-ui/react";
import { ChatState } from "../../context/ChatProvider";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment";
import { useAuth } from "../../context/auth";
import { LanguageContext } from "../../context/LanguageContext";
import SocketContext from "../../context/SocketContext";
//new chat layout
const PRIMARY = "#34c3c9";
const ThreadItem = ({
  active,
  name,
  last,
  time,
  avatar,
  unread,
  users,
  chat,
  onClick,
  user,
  partner,
  cardClick,
}) => {
  const navigate = useNavigate();
  console.log(chat,'chat?.isGroupChat');
  return (
    <button
      onClick={cardClick}
      className={`flex w-full items-center gap-3 rounded-xl px-3 py-2 text-left transition ${
        active
          ? "bg-white shadow-sm ring-1 ring-[#e9e9e9]"
          : "hover:bg-white/60"
      }`}
    >
      <img
        className="grid h-9 w-9 place-items-center rounded-full font-semibold"
        style={{ background: PRIMARY + "20", color: PRIMARY }}
        src={
          chat?.isGroupChat
            ? require("../../pages/image/groupchat.png")
            : partner?.profileImage?partner?.profileImage.startsWith("http")? partner?.profileImage
            : `${BASE_URL}/uploads/${partner.profileImage}`
            : require("../../pages/image/addphotoicon.png")
        }
        onClick={(e) => {
          e.stopPropagation(); // Prevent parent click event
          let other = getSenderFull(user, users);
          navigate(`/ambassadoruserprofile?id=${other?._id}`);
        }}
      />

      <div className="min-w-0 flex-1">
        <div className="flex items-baseline justify-between gap-2">
          <div className="truncate text-[15px] font-semibold text-slate-900">
            {name}
          </div>
          <div className="whitespace-nowrap text-xs text-slate-500">{time}</div>
        </div>
        <div className="truncate text-xs text-slate-500">{last}</div>
      </div>
      {unread > 0 && (
        <span
          className="ml-1 grid h-5 w-5 place-items-center rounded-full bg-[var(--primary)] text-[10px] font-medium text-white"
          style={{ ["--primary"]: PRIMARY }}
        >
          {unread}
        </span>
      )}
    </button>
  );
};

const MyChats = ({ fetchAgain }) => {
  const { lg } = useContext(LanguageContext);
  const socket = useContext(SocketContext);
  const location = useLocation(); // includes query string, e.g., ?source=external

  useEffect(() => {
    if (!socket) return;

    // Listen for incoming chat request
    socket.on("chat_request", ({ userId, ambassadorId, chatId }) => {
      console.log("Received chat request", { userId, ambassadorId, chatId });

      //  fetchChats()
    });

    // Cleanup on unmount
    return () => {
      socket.off("chat_request");
    };
  }, [socket]);
  const [loggedUser, setLoggedUser] = useState();
  const navigate = useNavigate();
  const { selectedChat, setSelectedChat, user, chats, setChats } = ChatState();

  const toast = useToast();
  console.log("pak", selectedChat);
  const fetchChats = async () => {
    // console.log(user._id);
    try {
      const { data } = await axios.get(`api/v1/chat/fetch/${user._id}`);
      if (data || data.length !== 0) {
        setSelectedChat(data[0]); // Set the first chat as selected by default
      }
      setChats(data);
    } catch (error) {
      toast({
        title: "Error Occured!",
        description: "Failed to Load the chats",
        status: "error",
        duration: 5000,
        isClosable: true,
        position: "bottom-left",
      });
    }
  };

  useEffect(() => {
    setLoggedUser(user);
    fetchChats();
    // eslint-disable-next-line
  }, [fetchAgain, location.search]);

  const [auth, setAuth] = useAuth(); // If using Context API

  const userId = auth?.user?._id;

  const [users, setUsers] = useState(null);

  useEffect(() => {
    const fetchUser = async () => {
      if (!userId) return; // Don't make API call if userId is undefined
      try {
        const res = await axios.get(`/api/v1/auth/user-profile/${userId}`);
        setUsers(res.data.data);
      } catch (err) {
        console.error("Error:", err);
      }
    };

    fetchUser();
  }, [userId]);

  const getChatPartner = (users) => {
    return users?.find((u) => u._id !== user._id);
  };
  // new chat layout
  const [activeId, setActiveId] = useState(2);
  const [text, setText] = useState("");
  const endRef = useRef(null);
  useEffect(() => {
    endRef.current?.scrollIntoView({ behavior: "smooth" });
  }, []);

  return (
    <>
      {/* <Box
        display={{ base: selectedChat ? "none" : "flex", md: "flex" }}
        flexDir="column"
        alignItems="center"
        p={3}
        px={0}
        bg="#d9d9d952"
        w={{ base: "100%", lg: "25%", md: "34%" }}
        borderRadius="lg"
        borderWidth="1px"
        h="100vh"
        overflowY="auto"
        sx={{

          "&::-webkit-scrollbar": {
            display: "none",
          },

          scrollbarWidth: "none",
          msOverflowStyle: "none",
        }}
      >
        <Box
          pb={3}
          px={3}
          fontSize={{ base: "28px", md: "30px" }}

          d="flex"
          w="100%"
          justifyContent="space-between"
          alignItems="center"
        >
          <div className="fw-bold pt-3  font22" style={{ fontSize: "26px" }}>

            {lg?.msgtext}
          </div>

        </Box>
        <Box
          d="flex"
          flexDir="column"
          p={3}
          px={0}
          bg="transparent"
          w="100%"
          h="calc(100% - 57px)"
          borderRadius="lg"

        >
          {chats ? (

            <Stack>
              {chats?.map((chat) => {
                const partner = getChatPartner(chat.users);
                console.log("Profile image path:", partner?.profileImage);

                return (
                  <Box

                    onClick={() => {
                      navigate("/chatChak/" + chat._id);
                      setSelectedChat(chat);
                      localStorage.setItem(
                        "selectedUser",
                        JSON.stringify(chat)
                      );
                    }}
                    cursor="pointer"
                    bg={selectedChat === chat ? "#d0cece" : "transparent"}
                    color={selectedChat === chat ? "black" : "black"}
                    px={4}
                    py={2}
                    minH={"65px"}
                    // borderRadius="lg"
                    key={chat?._id}
                  >
                    <div className="d-flex gap-3">
                      <img
                        src={
                          partner?.profileImage
                            ? `${BASE_URL}/uploads/${partner.profileImage}`
                            : require("../../pages/image/addphotoicon.png")
                        }
                        alt={`${partner?.name || "User"} photo`}
                        onClick={(e) => {
                          e.stopPropagation();
                          let other = getSenderFull(user, chat?.users);
                          navigate(`/ambassadoruserprofile?id=${other?._id}`);
                        }}
                        style={{
                          cursor: "pointer",
                          width: "100%",
                          maxWidth: "55px",
                          height: "55px",
                          borderRadius: "50%",
                        }}
                      />
                      <div className="d-flex align-items-center gapchatbox  ">
                        <div>
                          <Text
                            className="fs-5 mt-2 fw-bold mb-0 chatfzname "

                          >
                            {!chat?.isGroupChat
                              ? getSender(user, chat?.users)
                              : chat?.chatName}
                          </Text>

                          {chat?.latestMessage && (
                            <Text fontSize="xs">
                              <b>{chat?.latestMessage?.sender?.name} </b>
                              {chat?.latestMessage?.content?.length > 14
                                ? chat?.latestMessage?.content?.substring(
                                  0,
                                  15
                                ) + "..."
                                : chat?.latestMessage?.content}
                              {chat?.latestMessage?.image ? "Media" : ""}
                            </Text>
                          )}
                        </div>
                        <div>
                          <small className=" fw600 " style={{ width: "50px" }}>
                            {" "}
                            {chat?.latestMessage?.createdAt
                              ? moment(chat.latestMessage.createdAt).fromNow()
                              : ""}
                          </small>
                        </div>
                      </div>
                    </div>
                  </Box>
                );
              })}
            </Stack>
          ) : (
            <ChatLoading />
          )}
        </Box>
      </Box> */}

      {/* Left: thread list */}
      <aside className="rounded-2xl border border-[#eee] bg-white p-3 shadow-sm">
        <div className="mb-3 flex items-center justify-between">
          <div className="text-[18px] font-semibold"> {lg?.msgtext}</div>
        </div>
        <div className="mb-3 flex items-center gap-2 rounded-xl bg-[#f4f6f7] px-3 py-2 ring-1 ring-[#e9e9e9]">
          <Search size={16} className="text-slate-500" />
          <input
            placeholder="Search"
            className="w-full bg-transparent text-sm outline-none"
          />
        </div>
        <div className="flex flex-col max-h-[63vh] gap-1 overflow-auto">
          {chats ? (
            chats?.map((chat) => {
              const partner = getChatPartner(chat.users); // This gets the other user in chat
              console.log("Profile image path:", partner?.profileImage); // <--- Add this line
              return (
                <ThreadItem
                  key={chat?._id}
                  active={chat?._id === activeId}
                  {...chat}
                  cardClick={() => {
                    setSelectedChat(chat);
                    localStorage.setItem("selectedUser", JSON.stringify(chat)); // ✅ persist
                    navigate("/chatChak/" + chat?._id);
                  }}
                  partner={partner}
                  user={user}
                  chat={chat}
                  sender={chat?.latestMessage?.sender?.name}
                  time={
                    chat?.latestMessage?.createdAt
                      ? moment(chat.latestMessage.createdAt).fromNow()
                      : ""
                  }
                  name={
                    !chat?.isGroupChat
                      ? getSender(user, chat?.users)
                      : chat?.chatName
                  }
                  last={
                    chat?.latestMessage?.image
                      ? "Media"
                      : chat?.latestMessage?.content?.length > 14
                      ? chat?.latestMessage?.content.substring(0, 15) + "..."
                      : chat?.latestMessage?.content
                  }
                  onClick={(e) => {
                    setActiveId(chat?._id);
                  }}
                />
              );
            })
          ) : (
            <ChatLoading />
          )}
          {/* {threads.map((t) => (
            <ThreadItem
              key={t.id}
              active={t.id === activeId}
              {...t}
              onClick={() => setActiveId(t.id)}
            />
          ))} */}
        </div>
      </aside>

      {/* Right: chat panel */}
    </>
  );
};

export default MyChats;
